(function () {
  // 初始化标题导航
  const contentCantainer = document.getElementById("unique-content");
  if (contentCantainer) {
    // get hashRouter cantainer
    const navigationContainer = document.getElementById("unique-navigation");
    // get h2 tags
    const h2s = contentCantainer.getElementsByTagName("h2");
    let items;
    for (const h2 of h2s) {
      const item = document.createElement("div");
      item.classList.add("unique-navigation-item");
      item.textContent = h2.textContent;
      navigationContainer.appendChild(item);
    }
    items = navigationContainer.querySelectorAll(".unique-navigation-item");

    // const imgDoms = contentCantainer.getElementsByTagName('img');

    // for (let i = 0; i < imgDoms.length; i++) {
    //     const dom = imgDoms[i];
    //     dom.src = dom.src + (dom.src.includes('https://file.aitubo.ai/') ? '!w1280' : '');
    // }
    items.forEach((item) => {
      item.addEventListener("click", () => {
        items.forEach((itm) =>
          itm.classList.remove("unique-navigation-item-active")
        );
        item.classList.add("unique-navigation-item-active");
        for (const h2 of h2s) {
          if (h2.textContent === item.textContent) {
            h2.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      });
    });

    window.addEventListener("scroll", () => {
      items.forEach((itm) =>
        itm.classList.remove("unique-navigation-item-active")
      );
      for (const h2 of h2s) {
        if (
          document.documentElement.scrollTop +
            document.documentElement.clientHeight / 2 >=
          h2.offsetTop
        ) {
          items.forEach((item) => {
            item.classList.remove("unique-navigation-item-active");
            if (h2.textContent === item.textContent) {
              item.classList.add("unique-navigation-item-active");
            }
          });
        }
      }
    });
  }

  // 初始化 cta 内容
  const ctaMap = {
    default: {
      rightTitle: "Turn your ideas into ready-to-share videos",
      rightImage:
        "https://shortvideo-02.oss-us-east-1.aliyuncs.com/assets/web/blog/home1.png",
      footerTitle: "Stop Wasting Time on Video Creation",
      footerDesc: "Turn any idea to stunning video in minutes.",
      jumpPath: "/",
    },
    video: {
      rightTitle: "Create stunning videos effortlessly",
      rightImage:
        "https://vidfly-02.oss-us-east-1.aliyuncs.com/blog/images/right-video.webp",
      footerTitle: "Create Videos in Minutes",
      footerDesc:
        "Transform text and images into high-quality videos with ease.",
      jumpPath: "/ai-video-generator/",
    },
    script: {
      rightTitle: "Turn your script into videos instantly",
      rightImage:
        "https://vidfly-02.oss-us-east-1.aliyuncs.com/blog/images/right-script.webp",
      footerTitle: "From Script to Video",
      footerDesc: "Generate professional videos directly from your script.",
      jumpPath: "/script-to-video/",
    },
    caption: {
      rightTitle: "Add perfect captions to your videos",
      rightImage:
        "https://vidfly-02.oss-us-east-1.aliyuncs.com/blog/images/right-caption.webp",
      footerTitle: "Add Captions Seamlessly",
      footerDesc: "Make your videos more engaging with AI-generated captions.",
      jumpPath: "/",
    },
  };

  const tagsCantainer = document.querySelector("#blog-tags");

  if (tagsCantainer) {
    let key = "default";
    const tagDoms = tagsCantainer.querySelectorAll("a");

    for (let i = 0; i < tagDoms.length; i++) {
      const tagDom = tagDoms[i];

      const tagText = tagDom.innerText;

      if (tagText === "AI Video Generator") {
        key = "video";
        break;
      }

      if (tagText === "Script to Video") {
        key = "script";
        break;
      }

      if (tagText === "Video Caption") {
        key = "caption";
        break;
      }
    }

    const detail = ctaMap[key];

    // const rightWrap = document.querySelector('.unique-right-wrap');
    const rightText = document.querySelector(".unique-right-text");
    const rightA = document.querySelector(".unique-a");
    const rightBtn = document.querySelector(".unique-right-btn");
    rightText.textContent = detail.rightTitle;
    rightA.setAttribute("href", detail.jumpPath);
    rightBtn.textContent = "Start Now";
    // 添加右侧图片
    const rightImgDom = document.querySelector(".unique-right-img");

    const coverDom = document.createElement("img");
    coverDom.src = detail.rightImage;
    coverDom.alt = detail.rightTitle;

    rightImgDom.appendChild(coverDom);

    // 添加右侧文字和按钮
    // const contentDom = document.createElement('div');
    // contentDom.className = 'unique-right-content';

    // contentDom.innerHTML =  `
    //     <p class="unique-right-text">${detail.rightTitle}</p>
    //     <a href="${detail.jumpPath}">
    //         <div class="unique-right-btn">Get Started</div>
    //     </a>
    // `;

    // rightImgDom.parentElement.appendChild(contentDom);

    // 添加 footer 的文案
    // const footerCatDom = document.querySelector('.unique-cta');
    const footerCtaTitle = document.querySelector(".cta-title");
    const footerCtaText = document.querySelector(".cta-text");
    const footerCtaA = document.querySelector(".cta-a");
    const footerCtaBtn = document.querySelector(".cta-btn");
    footerCtaTitle.textContent = detail.footerTitle;
    footerCtaText.textContent = detail.footerDesc;
    footerCtaA.setAttribute("href", detail.jumpPath);
    footerCtaBtn.textContent = "Start Creating Now";
    // footerCatDom.innerHTML = `
    //     <p class="cta-title">${detail.footerTitle}</p>
    //     <p class="cta-text">${detail.footerDesc}</p>
    //     <a href="${detail.jumpPath}">
    //         <div class="cta-btn">Get Started</div>
    //     </a>
    // `
  }
})();
